import request from "../../Frontends/Common/utils/request/requestMain";
const _ = require("lodash");
const rootRoute = "/addressprogramarchived/channel/";

export default class ChannelApi {
  constructor() {
    this.defaultModel = {
    };
  }
  async getChannels(params) {
    return await request.post(`${rootRoute}getChannels`, {
      filter: params,
      parameters: {},
    });
  }
  async getChannel(id) {
    return await request.post(`${rootRoute}getChannels`, {
      filter: `$filter=Id eq ${id}`,
      parameters: {},
    });
  }
  async createChannel(model) {
    const data = [_.merge(_.cloneDeep(this.defaultModel), model)];
    return await request.post(`${rootRoute}createChannel`, { data });
  }
  async deleteChannel(model) {
    const data = [model];
    return await request.post(`${rootRoute}deleteChannel`, { data });
  }
  async editChannel(model) {
    const data = [_.merge(_.cloneDeep(this.defaultModel), model)];
    return await request.post(`${rootRoute}updateChannel`, { data });
  }
  async import(gfid) {
    return await request.post(`${rootRoute}importChannel`, {
      gfid: gfid
    });
  }
  async getImportScaffold() {
    return await request.post(`${rootRoute}getChannelimporttemplate`, null, {responseType: 'blob'});
  }
  async export(filter, format) {
    return await request.post(`${rootRoute}exportChannel`, {
      filter: filter,
      format: format
    });
  }
}
